import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./ApplicationDevelopment.css";
import Testimonial from "../../../Testimonial/Testimonial";

const ApplicationDevelopment = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>
          Application Development | Comprehensive Tech Stack & Development Tools
        </title>
        <meta
          name="description"
          content="Explore our full-stack application development capabilities with cutting-edge technologies including web frameworks, mobile development, blockchain, AI, and database solutions."
        />
        <meta
          name="keywords"
          content="application development, web development, mobile app development, software development, full-stack development, frontend development, backend development, Angular development, React development, Vue.js, JavaScript frameworks, HTML5, CSS3, Bootstrap, responsive design, mobile-first development, progressive web apps, cross-platform development, Flutter, React Native, Ionic, Node.js, Django, Laravel, PHP development, Python development, database solutions, MongoDB, MySQL, PostgreSQL, SQL Server, Amazon DynamoDB, MariaDB, blockchain development, Ethereum, Hyperledger, Solidity, smart contracts, ERC-20, Web3, decentralized apps, AI integration, artificial intelligence, machine learning, data science, IoT development, Internet of Things, AR/VR development, augmented reality, virtual reality, cloud application development, enterprise application development, custom software solutions, API development, microservices architecture, DevOps, CI/CD, agile development, UI/UX design, scalable applications, high-performance apps"
        />
      </Helmet>

      <div className="mk-appdev-container">
        <section className="mk-appdev-hero">
          <div className="mk-appdev-hero-content">
            <h1 className="mk-appdev-title">
              Application Development & Management
            </h1>
            <p className="mk-appdev-subtitle">
              Transform your business with custom applications built for
              performance, scalability, and growth
            </p>
            <button className="mk-appdev-cta-btn">Get Started</button>
          </div>
          <div className="mk-appdev-hero-animation">
            <div className="mk-appdev-circle mk-appdev-circle-1"></div>
            <div className="mk-appdev-circle mk-appdev-circle-2"></div>
            <div className="mk-appdev-circle mk-appdev-circle-3"></div>
          </div>
        </section>

      <section className="mk-appdev-services">
        <h2 className="mk-appdev-section-title">Our Application Services</h2>
        <div className="mk-appdev-services-grid">
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-web"></div>
            </div>
            <h3>Web Application Development</h3>
            <p>Custom web applications tailored to your specific business needs with modern frameworks and technologies.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-mobile"></div>
            </div>
            <h3>Mobile App Development</h3>
            <p>Native and cross-platform mobile applications for iOS and Android that deliver exceptional user experiences.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-cloud"></div>
            </div>
            <h3>Cloud Application Solutions</h3>
            <p>Scalable cloud-based applications that grow with your business and ensure high availability.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-crm"></div>
            </div>
            <h3>CRM Software Solutions</h3>
            <p>Custom Customer Relationship Management systems to streamline your sales, marketing, and customer service processes.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-erp"></div>
            </div>
            <h3>ERP System Development</h3>
            <p>Enterprise Resource Planning solutions that integrate all facets of your business operations into a unified system.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-ecommerce"></div>
            </div>
            <h3>E-Commerce Platforms</h3>
            <p>Custom online store solutions with secure payment gateways, inventory management, and customer analytics.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-dashboard"></div>
            </div>
            <h3>Business Intelligence Dashboards</h3>
            <p>Interactive data visualization tools that transform your business data into actionable insights.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-workflow"></div>
            </div>
            <h3>Workflow Automation</h3>
            <p>Custom software solutions that automate repetitive tasks and streamline your business processes.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-api"></div>
            </div>
            <h3>API Development & Integration</h3>
            <p>Custom API solutions and seamless integration between your existing software systems.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-ai"></div>
            </div>
            <h3>AI & Machine Learning Solutions</h3>
            <p>Intelligent applications powered by artificial intelligence and machine learning algorithms for predictive analytics and automation.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-iot"></div>
            </div>
            <h3>IoT Application Development</h3>
            <p>Connected applications for Internet of Things ecosystems that collect, process, and analyze data from smart devices.</p>
          </div>
          
          <div className="mk-appdev-service-card">
            <div className="mk-appdev-service-icon">
              <div className="mk-appdev-icon-maintenance"></div>
            </div>
            <h3>Application Maintenance & Support</h3>
            <p>Comprehensive maintenance and support services to keep your applications running smoothly.</p>
          </div>
        </div>
      </section>

        <section className="mk-appdev-process">
          <h2 className="mk-appdev-section-title">Our Development Process</h2>
          <div className="mk-appdev-process-steps">
            <div className="mk-appdev-process-step">
              <div className="mk-appdev-step-number">01</div>
              <h3>Discovery & Planning</h3>
              <p>
                We analyze your requirements and create a detailed project plan.
              </p>
            </div>
            <div className="mk-appdev-process-step">
              <div className="mk-appdev-step-number">02</div>
              <h3>Design & Prototyping</h3>
              <p>
                We create intuitive UI/UX designs and interactive prototypes.
              </p>
            </div>
            <div className="mk-appdev-process-step">
              <div className="mk-appdev-step-number">03</div>
              <h3>Development & Testing</h3>
              <p>
                We build your application with agile methodology and rigorous
                testing.
              </p>
            </div>
            <div className="mk-appdev-process-step">
              <div className="mk-appdev-step-number">04</div>
              <h3>Deployment & Support</h3>
              <p>We deploy your application and provide ongoing maintenance.</p>
            </div>
          </div>
        </section>

        <section className="mk-appdev-cta">
          <div className="mk-appdev-cta-content">
            <h2>Ready to Transform Your Business with Custom Applications?</h2>
            <p>
              Contact us today for a free consultation and project estimate.
            </p>
            <a href="/contact-us">
              <button className="mk-appdev-cta-btn">Contact Us</button>
            </a>
          </div>
        </section>
      </div>

      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationDevelopment;
